<div class="row">
  <fieldset style="padding: 1em;" class="col-md-3 bg-white mb-2 px-3 pb-0 mx-0 bg-white radius8 " multiple>
    <legend style="font-size: smaller;" class="form-label">Select a topic
    </legend>

    <mat-button-toggle-group style="font-size: smaller;margin-bottom: 2em;width: 100%;"
      hideSingleSelectionIndicator="true" (change)="fetchDataAlertItems($event.value)" name="subscriptionTypes"
      aria-label="Data Alert Types" vertical>
      @if (isLoading) {
      <mat-button-toggle [disabled]="true" class="notification-type-options">
        <mat-icon>hourglass_empty</mat-icon>
        <span class="button-text">Loading...</span>
      </mat-button-toggle>
      }
      @else if (dataAlertCategories.length==0) {
      <mat-button-toggle [disabled]="true" class="notification-type-options">
        <span class="button-text">No data alerts are available.</span>
      </mat-button-toggle>
      }

      <mat-button-toggle *ngFor="let subscriptionType of dataAlertCategories" [checked]="subscriptionType.isFiltered"
        [value]="subscriptionType" (change)="handlesubscriptionTypeChange(subscriptionType, $event.source.checked)"
        title="{{subscriptionType.categoryName}}" class="notification-type-options">
        <mat-icon
          [style.visibility]="subscriptionType.isFiltered ? 'visible' : 'hidden'">check_circle_outline</mat-icon>
        <span class="button-text-no-icon">
          {{subscriptionType.categoryName}}&nbsp;
          <span disabled style="position: absolute;top:2px;right: 2px;" 
          [hidden]="subscriptionType.subscriptionCount==0"
            class="badge badge-secondary warning"
            [title]="subscriptionType.subscriptionCount">
            {{subscriptionType.activeCount}}
          </span>
        </span>

      </mat-button-toggle>
    </mat-button-toggle-group>
    <div style="text-align: right;">
      <button type="button" class="btn theme-btn-outline cursor-pointer px-2" *ngIf="canPauseAll" (click)="pause_all()">
          Pause All
        </button>&nbsp;
        <button type="button" class="btn theme-btn-outline cursor-pointer px-2" *ngIf="canResumeAll" (click)="resume_all()">
          Resume All
        </button>
    </div>
  </fieldset>

  <mat-list class="col-md-9 mb-2 px-3 pb-0 mx-0" style="padding-top: 0;">
    <mat-list-item *ngFor="let item of AlertTypes" class="mb-2 px-3 pb-0 mx-0 bg-white radius8 "
      style="border-radius: 8px; padding:4px">
      <div matListItemIcon>
        <mat-icon color="primary" *ngIf="item.mySubscription!=null && item.mySubscription.endDate==null">notifications_active</mat-icon>
        <mat-icon *ngIf="item.mySubscription!=null && item.mySubscription.endDate!=null">notifications_paused</mat-icon>
        <mat-icon *ngIf="item.mySubscription==null">notifications_off</mat-icon>
      </div>
      <div matListItemTitle [style.text-decoration]="item.isEnabled? 'none':'line-through'"><b>{{item.dataAlertName}}</b></div>
      <div matListItemLine>
        {{item.dataAlertDescription}}

      </div>
      <div matListItemLine *ngIf="item.mySubscription!=null">
        <em class="px-2 mb-0" [title]="item.mySubscription.startDate  | date : 'dd/MM/yyyy HH:mm:ss'">
          @if(item.mySubscription.endDate==null){
            Subscribed On: {{item.mySubscription.startDate | date : 'dd/MM/yyyy'}}
          }
          @else{
            Paused On: {{item.mySubscription.startDate | date : 'dd/MM/yyyy'}}
          }
        </em>
      </div>
      <div matListItemMeta>
        <button type="button" class="btn theme-btn-outline cursor-pointer px-2" 
          *ngIf="item.mySubscription==null && item.isEnabled"
          (click)="subscribe_to_alert(item)">
          &nbsp;&nbsp;Subscribe&nbsp;&nbsp;
        </button>
        <button type="button" class="btn theme-btn-outline px-2 notify-decline-btn cursor-pointer"
          *ngIf="item.mySubscription!=null && item.isEnabled && item.mySubscription.endDate!=null " 
          (click)="subscribe_to_alert(item)">
          &nbsp;&nbsp;&nbsp;Resume&nbsp;&nbsp;&nbsp;
        </button>

        <button type="button" class="btn theme-btn-outline px-2 notify-decline-btn cursor-pointer"
          *ngIf="item.mySubscription!=null && item.isEnabled  && item.mySubscription.endDate==null " (click)="unsubscribe_from_alert(item)">
          Unsubscribe
        </button>
        <button type="button" class="btn theme-btn-outline px-2 notify-decline-btn cursor-pointer"
          *ngIf="item.mySubscription!=null && (!item.isEnabled ||item.mySubscription.endDate!=null )" (click)="unsubscribe_from_alert(item)">
          Remove
        </button>
      </div>
    </mat-list-item>

    <div *ngIf="!AlertTypes.length" class="noDataFound">
      <h1 class="no-data-found-heading">{{'No alert subscriptions found'}}</h1>
    </div>
  </mat-list>
</div>